var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 9.69026V9.60002M12 9.69026V9.60002M16.8 9.69026V9.60002M11.687 16.5913L6.67826 21.6V16.5913H4.8C3.47452 16.5913 2.4 15.5168 2.4 14.1913V4.80003C2.4 3.47454 3.47452 2.40002 4.8 2.40002H19.2C20.5255 2.40002 21.6 3.47454 21.6 4.80002V14.1913C21.6 15.5168 20.5255 16.5913 19.2 16.5913H11.687Z",
    stroke: "#00123A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.a663f1c9bc2160e865d6bc90fa7a1d31.svg";
export { ForwardRef as ReactComponent };